module.exports = __webpack_public_path__ + "images/application/team/shelley-223c8469.jpg";